import { Link } from "react-router-dom";
import { categories, channels } from "@/mocks/news";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className="ri-fire-fill" />
              </span>
              <span className="font-heading font-black text-xl text-background-50">吃瓜爆料网</span>
            </div>
            <p className="text-sm text-background-200 leading-relaxed">
              第一时间聚合最新娱乐新闻、明星八卦与独家爆料，覆盖影视、音乐、综艺等多个领域，做你身边最懂娱乐圈的资讯伙伴。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-qq-fill", "ri-video-fill"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-100 text-lg"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4">
              <Link to="/" className="cursor-pointer hover:text-accent-400 transition-colors">
                热门分类
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4">专题频道</h4>
            <ul className="space-y-2.5 text-sm">
              {channels.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/channel/${c.slug}`}
                    className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  团队与业务
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  投稿爆料
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 吃瓜爆料网 · 本站为前端演示站点，所有内容均为示例数据</p>
          <p className="flex flex-wrap items-center justify-center gap-4">
            <span className="cursor-pointer hover:text-accent-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-accent-400 transition-colors">免责声明</span>
            <span className="cursor-pointer hover:text-accent-400 transition-colors">联系我们</span>
          </p>
        </div>
      </div>
    </footer>
  );
}